import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CustomerDisplayData, UserShortInfo } from "../../types";
import ShortManInfo from "../../components/ui/shortItem";
import { closeModal, openModal } from "../../state/modalSlice";
import CustomerEditorModal from "../../modals/customer/editCustomer";
import CommentsList from "../../components/comments/list";
import { commentBackend, CommentOutput, userBackend } from "../../services";
import { UpdateUserCustomerType } from "../../forms/editCustomer";
import { actions, RootState } from "../../state/reducer";
import { formatDateTimeStandard, generateRandomString } from "../../utils";
import CustomerAddUserModal from "../../modals/customer/updateCustomerUser";

interface ClientInfoPanelProps {
  data: CustomerDisplayData;
}

const ClientInfoPanel: React.FC<ClientInfoPanelProps> = ({ data }) => {
  const dispatch = useDispatch();
  const [responsible, setResponsible] = useState<UserShortInfo | null>(null);
  const [comments, setComments] = useState<CommentOutput[]>([]);
  const State = useSelector((state: RootState) => state);
  const handleOpenEditModal = () => {
    dispatch(
      openModal({
        component: CustomerEditorModal,
        context: {
          onSave: (data: UpdateUserCustomerType) => {
            dispatch(actions.selectItem(generateRandomString(4)));
          },
          closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
        },
      })
    );
  };

  const handleOpenUserModal = () => {
    dispatch(
      openModal({
        component: CustomerAddUserModal,
        context: {
          event_id: data.id,
          onSave: (data: UpdateUserCustomerType) => {
            if (!data) 
            dispatch(actions.selectItem(generateRandomString(4)));
          },
          closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
        },
      })
    );
  };

  const stateUpdate = State.selectedItem;

  const responsible_id =
    data.users?.find((item) => item.role_id === 2);

  useEffect(() => {
    if (responsible_id) {
      userBackend.userShortInfo(responsible_id.user_id).then((res) => {
        if (res) {
          setResponsible(res.user);
        }
      });
    }
  }, [responsible_id, State.selectedItem]);

  useEffect(() => {
    commentBackend.getComments(data.id, 3).then((res) => {
      if (res) setComments(res.comments);
    });
  }, [data, stateUpdate]);

  return (
    <div className="columnCenter panelColumn2 gap24">
      <div className="panel eventListPanel">
        <div className="flex between">
          <h2 className="detailHeading">{`${data.first_name} ${data.last_name} (клиент)`}</h2>
        </div>
        <div className="flex between vertCenter" style={{ marginTop: 40 }}>
          <div className="detailSubHeading" style={{ marginTop: 0 }}>
            Основная информация
          </div>
          <a className="aBtn" onClick={handleOpenEditModal}>
            Редактировать
          </a>
        </div>
        <div className="flex between">
          <div className="labelItem">
            <div className="labelHeading">Номер телефона</div>
            <div className="labelText">{data.phone}</div>
          </div>
          <div className="labelItem">
            <div className="labelHeading">Создан</div>
            <div className="labelText">
              {data.date_created
                ? formatDateTimeStandard(data.date_created)
                : ""}
            </div>
          </div>
        </div>
        <div className="detailSubHeading">Описание</div>
        <div>{data.description || ""}</div>
        <div>
          <div className="detailSubHeading">Дополнительные данные</div>
          <div className="flex between">
            {data.metadata?.map((contact, index) => (
              <div key={index} className="labelItem">
                <div className="labelHeading">{contact.key}</div>
                <div className="labelText">{contact.value}</div>
              </div>
            ))}
          </div>
        </div>
        {data.source && <div>
          <div className="detailSubHeading">Источник</div>    
          <div className="labelItem">
            <div className="labelHeading">{data.source.name}</div>
          </div>              
        </div>}
        <div>
          <div className="detailSubHeading">Ответственный</div>
          <div className="flex gap24">
            <div className="labelItem">
              {responsible_id? <ShortManInfo
                photo={responsible?.photoUrl}
                name={`${responsible?.last_name || ""} ${
                  data.responsible?.first_name || ""
                }`}
                phone={responsible?.phone}
              /> : <div className="userRoleTableText gray">Не назначен</div>}
            </div>
            <a onClick={handleOpenUserModal}>Назначить</a>
          </div>
        </div>
      </div>
      <div className="panel eventListPanel">
        <CommentsList comments={comments} tab={3} item={data.id} />
      </div>
    </div>
  );
};

export default ClientInfoPanel;
